import { Component, OnInit } from "@angular/core";
import { MediaObserver, MediaChange } from "@angular/flex-layout";
import { Subscription } from "rxjs";
import { LoginService } from "../servicios/login-service.service";
import { MenuService } from "../servicios/menu.service";
import { HelperService } from "../servicios/helper.service";
import { Constants } from "../constants/constants";
import { Renderer2 } from "@angular/core";
//import { element } from '@angular/core/src/render3';

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.css"],
})
export class NavigationComponent implements OnInit {
  ambienteVersion = "";
  opened = true;
  over = "side";
  expandHeight = "42px";
  collapseHeight = "42px";
  displayMode = "flat";

  opcionActual = {
    opcion: "Inicio",
    ruta: "/inicio",
    icon: "home",
  };

  usuario = "";

  menuOptions = [];
  /*menuOptions =
    [

      {
        "opcion": "Inicio",
        "icon": "home",
        "ruta": "/inicio",
        "hasChildren": false
      },
      {
        "opcion": "Administracion",
        "icon": "record_voice_over",
        "hasChildren": true,
        "children": [
          {
            "opcion": "Nuevo",
            "ruta": "/creacionusuarios",
            "icon": "add_circle"
          },
          {
            "opcion": "Gestión",
            "ruta": "/gestionusuarios",
            "icon": "search"
          }
        ]
      },
      {
        "opcion": "Cuentas",
        "icon": "perm_contact_calendar",
        "hasChildren": true,
        "children": [
          {
            "opcion": "Nueva",
            "ruta": "/inicio",
            "icon": "add_circle"
          },
          {
            "opcion": "Consultar",
            "ruta": "/inicio",
            "icon": "search"
          }
        ]
      },
      {
        "opcion": "Contactos",
        "icon": "contacts",
        "hasChildren": true,
        "children": [
          {
            "opcion": "Nueva",
            "ruta": "/inicio",
            "icon": "add_circle"
          },
          {
            "opcion": "Consultar",
            "ruta": "/inicio",
            "icon": "search"
          }
        ]
      },
      {
        "opcion": "Informes",
        "icon": "assignment",
        "hasChildren": true,
        "children": [
          {
            "opcion": "General",
            "ruta": "/inicio",
            "icon": "call_split"
          },
          {
            "opcion": "Especifico",
            "ruta": "/inicio",
            "icon": "call_merge"
          }
        ]
      },
      {
        "opcion": "Administracion",
        "icon": "work",
        "hasChildren": true,
        "children": [
          {
            "opcion": "Usuarios",
            "ruta": "/inicio",
            "icon": "group"
          },
          {
            "opcion": "Configuracion",
            "ruta": "/inicio",
            "icon": "settings"
          }
        ]
      }

    ];*/

  private _fruits = ["Apple", "Banana", "Grapefruit"];
  watcher: Subscription;

  constructor(
    private renderer: Renderer2,
    media: MediaObserver,
    private servicioLogin: LoginService,
    private servicioMenu: MenuService,
    private _helper: HelperService
  ) {
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuario = infoUsuario[0].Nombre;
    this.watcher = media.media$.subscribe((change: MediaChange) => {
      if (change.mqAlias === "sm" || change.mqAlias === "xs") {
        this.opened = false;
        this.over = "over";
      } else {
        this.opened = true;
        this.over = "side";
      }
    });
  }

  ngOnInit() {
    // this._helper.each(this._fruits, console.log);

    let infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));

    this.servicioMenu.getMenu(infoUsuario[0].IdTpoUsuario).subscribe((data) => {
      //console.log(JSON.stringify(data));
      let menuJSON = [];
      let submenuJSON = [];
      menuJSON = this._helper.filter(data, function (menu) {
        return (
          menu.haschildren == 1 ||
          (menu.haschildren == 0 && menu.idpadre == null)
        );
      });

      //alert(JSON.stringify(menuJSON));
      submenuJSON = this._helper.filter(data, function (menu) {
        return menu.haschildren == 0 && menu.idpadre != null;
      });
      //console.log(JSON.stringify(submenuJSON));
      //alert(JSON.stringify(submenuJSON));

      menuJSON.forEach((element) => {
        if (element.haschildren == 1) {
          element.haschildren = true;
          element.children = [];
        } else {
          element.haschildren = false;
        }
      });

      //console.log(JSON.stringify(menuJSON));
      //console.log(JSON.stringify(submenuJSON));

      submenuJSON.forEach((element) => {
        let idPadre = element.idpadre;
        //alert(idPadre);
        //alert(JSON.stringify(menuJSON));
        let indiceMenu = this._helper.findIndex(menuJSON, { idmenu: idPadre });
        //alert(JSON.stringify(indiceMenu));
        if (element.haschildren == 1) {
          element.haschildren = true;
        } else {
          element.haschildren = false;
        }

        //console.log(JSON.stringify(menuJSON));
        //console.log(indiceMenu);
        menuJSON[indiceMenu].children.push({
          opcion: element.opcion,
          ruta: element.ruta,
          icono: element.icono,
          order: element.orden,
        });

        // alert(JSON.stringify(element));
        // alert(indiceMenu);
      });

      menuJSON.forEach((element) => {
        // alert(JSON.stringify(element));
        if (element.haschildren) {
          let valor = this._helper.sortBy(element.children, "order");
          // alert(JSON.stringify(valor));
          element.children = valor;
        }
      });
      // console.log(JSON.stringify(menuJSON));
      this.menuOptions = menuJSON;
      // console.log(JSON.stringify(this.menuOptions));
      /*data.forEach(element => {

      });*/
      // console.log(JSON.stringify(res));
    });

    this.ambienteVersionWeb();
  }

  thisRoute(item) {
    this.opcionActual = {
      opcion: item.opcion,
      ruta: item.ruta,
      icon: item.icon,
    };
    // alert(JSON.stringify(item));
  }

  logOut() {
    this.servicioLogin.setUserLoggedOut();
  }

  ambienteVersionWeb() {
    let ambiente: any = Constants.ROOT_AMBIENTE_VERSION_WEB;
    const parent: HTMLElement = document.getElementById("divMenu");

    if (ambiente.ambienteWeb == "QA") {
      this.renderer.setStyle(parent, "filter", "grayscale(100%)");
      this.ambienteVersion =
        ambiente.ambienteWebText + " Version: " + ambiente.versionWeb;
    } else if (ambiente.ambienteWeb == "PR") {
      this.renderer.setStyle(parent, "filter", "grayscale(0%)");
      this.ambienteVersion =
        ambiente.ambienteWebText + " Version: " + ambiente.versionWeb;
    } else if (ambiente.ambienteWeb == "LC") {
      this.renderer.setStyle(parent, "filter", "grayscale(0%)");
      this.ambienteVersion =
        ambiente.ambienteWebText + " Version: " + ambiente.versionWeb;
    }
  }
}
